import React from 'react';
var imageSizes = {
  small: "100px",
  medium: "200px",
  large: "300px"
};
export var textSizes = {
  "small": {
    fontSizeClass: "font-sm",
    renderHeading: function renderHeading(h) {
      return React.createElement("h5", null, h);
    }
  },
  "medium": {
    fontSizeClass: "",
    renderHeading: function renderHeading(h) {
      return React.createElement("h4", null, h);
    }
  },
  "large": {
    fontSizeClass: "font-lg",
    renderHeading: function renderHeading(h) {
      return React.createElement("h3", null, h);
    }
  }
};
export var getImageDimension = function getImageDimension(size) {
  if (size && imageSizes[size]) {
    return imageSizes[size];
  } else {
    throw "Unknown Testimonial Size: " + size;
  }
};